/* eslint-disable */
export const headCells = [
  {
    id: 'name',
    label: 'Name',
    minWidth: '206px',
    align: 'left',
  },
  {
    id: 'email',
    label: 'Email',
    minWidth: '250px',
    align: 'left',
  },
  {
    id: 'role',
    label: 'Role',
    minWidth: '123px',
    align: 'left',
  },
  {
    id: 'availability',
    label: 'Manages Availability',
    minWidth: '150px',
    align: 'left',
  },
  {
    id: 'status',
    label: 'License Status',
    minWidth: '140px',
    align: 'left',
  },
];

export const headCellsNoLicenseOrAvailability = [
  {
    id: 'name',
    label: 'Name',
    minWidth: '180px',
    align: 'left',
  },
  {
    id: 'email',
    label: 'Email',
    minWidth: '200px',
    align: 'left',
  },
  {
    id: 'isAdmin',
    label: 'IS ADMIN',
    minWidth: '150px',
    align: 'center',
  },
  {
    id: 'isProvider',
    label: 'IS PROVIDER',
    minWidth: '158px',
    align: 'center',
  },
];


export const memberFilters = {
  status: [
    {
      id: 'status1',
      name: 'Scheduled',
      type: 'status',
      code: 1,
    },
    {
      id: 'status2',
      name: 'Completed',
      type: 'status',
      code: 4,
    },
    {
      id: 'status3',
      name: 'Member Missed',
      type: 'status',
      code: 8,
    },
    {
      id: 'status4',
      name: 'Coach Missed',
      type: 'status',
      code: 10,
    },
    {
      id: 'status5',
      name: 'Cancelled',
      type: 'status',
      code: 5,
    },
    {
      id: 'status6',
      name: 'In Progress',
      type: 'status',
      code: 3,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/legacy/containers/Tables/NewTeamMembers/data/mockData.js